import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-custcardview43',
  templateUrl: './custcardview43.component.html',
  styleUrls: ['./custcardview43.component.css']
})
export class Custcardview43Component implements OnInit {

  @Input() customerId: number = 0;
  constructor() { }

  ngOnInit() {
  }

}
